import React, { useState } from 'react';
import { uploadDocument } from '../api';

function DocumentUploader() {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');

  const handleUpload = async () => {
    if (!file) return;
    try {
      await uploadDocument(file);
      setMessage('File uploaded successfully!');
    } catch {
      setMessage('Upload failed.');
    }
  };

  return (
    <div className="p-4 max-w-xl mx-auto">
      <input type="file" onChange={(e) => setFile(e.target.files[0])} />
      <button className="ml-2 bg-green-600 text-white px-3 py-1 rounded" onClick={handleUpload}>Upload</button>
      {message && <div className="mt-2 text-sm text-gray-700">{message}</div>}
    </div>
  );
}

export default DocumentUploader;
